"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormRadio = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["id", "children", "className", "alignMiddle", "labelClasses"];
var FormRadio = exports.FormRadio = function FormRadio(_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    _ref$alignMiddle = _ref.alignMiddle,
    alignMiddle = _ref$alignMiddle === void 0 ? false : _ref$alignMiddle,
    labelClasses = _ref.labelClasses,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var elementClasses = (0, _classnames["default"])('form-radio', className, {
    'form-radio_align-middle': alignMiddle
  });
  var elementLabelClasses = (0, _classnames["default"])('form-radio__label', labelClasses);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: elementClasses
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    id: id,
    type: "radio",
    className: "form-radio__input"
  }, inputProps)), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: elementLabelClasses
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "form-radio__icon"
  }), children));
};

// is only needed to avoid snapshots updating
FormRadio.defaultProps = {
  alignMiddle: false
};